"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileHint = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const qrcode_1 = require("qrcode");
const react_1 = require("react");
const BaseModal_1 = require("./ui/BaseModal");
const MobileHint = (props) => {
    const canvasRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        (0, qrcode_1.toCanvas)(canvasRef.current, props.url, function (error) {
            if (error)
                console.error(error);
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(BaseModal_1.BaseModal, { title: "Scannen Sie den QR-Code! / Scan the QR code!", onClose: () => props.onClose(), content: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("canvas", { ref: canvasRef }), (0, jsx_runtime_1.jsx)("p", { children: "Es tut uns leid, aber Ihr aktuelles Ger\u00E4t unterst\u00FCtzt die AR-Technologie, die f\u00FCr unser interaktives 3D-Triebwerk erforderlich ist, leider nicht. Scannen Sie einfach den QR-Code und integrieren Sie das virtuelle Triebwerk in Ihre Umgebung." }), (0, jsx_runtime_1.jsx)("p", { children: "Sorry! It seems your device doesn\u2019t support the AR technology required for our interactive 3D engine. Scan the QR code and integrate the virtual engine into your environment." })] }) }) }));
};
exports.MobileHint = MobileHint;
